import {
  deleteScope,
  getScopes,
  storeScope,
  updateScope
} from "../../api-helpers/contracts/api-scope-of-work";

export default {
  state: {
    isGettingScopes: false,
    scopes: null,
    isStoringScope: false,
    isUpdatingScope: false,
    isDeletingScope: false
  },
  mutations: {
    setIsGettingScopes(state, bool) {
      state.isGettingScopes = bool;
    },
    setScopes(state, scopes) {
      state.scopes = scopes;
    },
    setIsStoringScope(state, bool) {
      state.isStoringScope = bool;
    },
    setIsUpdatingScope(state, bool) {
      state.isUpdatingScope = bool;
    },
    setIsDeletingScope(state, bool) {
      state.isDeletingScope = bool;
    }
  },
  actions: {
    async getScopes({ state, commit }, contractId) {
      let scopes;
      if (!state.isGettingScopes && contractId) {
        commit("setIsGettingScopes", true);

        scopes = await getScopes(contractId);
        commit("setScopes", scopes);

        commit("setIsGettingScopes", false);
      }
      return scopes;
    },
    async storeScope({ state, commit, dispatch }, scope) {
      let response;
      if (!state.isStoringScope) {
        commit("setIsStoringScope", true);

        response = await storeScope(scope);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Scope of Work stored successfully.",
          errorText:
            "An error occurred while attempting to store Scope of Work.",
          afterSuccessFunction: () => {
            dispatch("getScopes", scope.contract_id);
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsStoringScope", false);
      }
      return response;
    },
    async updateScope({ state, commit, dispatch }, scope) {
      let response;
      if (!state.isUpdatingScope) {
        commit("setIsUpdatingScope", true);

        response = await updateScope(scope);
        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Scope of Work updated successfully.",
          errorText:
            "An error occurred while attempting to update Scope of Work.",
          afterSuccessFunction: () => {
            dispatch("getScopes", scope.contract_id);
            commit("resetCreateEditComponentParams");
          }
        });

        commit("setIsUpdatingScope", false);
      }
      return response;
    },
    async deleteScope({ state, commit, dispatch }, scope) {
      let response;
      if (!state.isDeletingScope) {
        commit("setIsDeletingScope", true);

        response = await deleteScope(scope);

        dispatch("handleApiResponse", {
          responseStatus: response,
          successText: "Scope of Work deleted successfully.",
          errorText:
            "An error occurred while attempting to delete Scope of Work.",
          afterSuccessFunction: () => {
            dispatch("getScopes", scope.contract_id);
            commit("resetConfirmationModalParams");
          }
        });

        commit("setIsDeletingScope", false);
      }
      return response;
    }
  }
};
